type Props = {
  provider: 'github' | 'atlassian';
  label: string;
  // null while pending so the pill can render "Checking…" instead of guessing
  connected: boolean | null;
  isPending: boolean;
};

export function ProviderRow({ provider, label, connected, isPending }: Props) {
  // While the connection state is unknown (`connected === null`, status still
  // loading) don't render an actionable Connect/Reconnect label or let the user
  // act — otherwise an already-connected user briefly sees "Connect".
  const pending = isPending || connected === null;
  const buttonLabel = pending
    ? `Checking ${label}…`
    : connected
      ? `Reconnect ${label}`
      : `Connect ${label}`;
  const onClick = () => window.location.assign(`/api/v1/integrations/${provider}/connect`);
  const pillText = pending ? 'Checking…' : connected ? 'Connected' : 'Not connected';
  const pillTone = pending ? 'text-slate-500' : connected ? 'text-emerald-700' : 'text-amber-700';

  return (
    <div className="grid grid-cols-[1fr_auto] items-center gap-3">
      <button
        type="button"
        onClick={onClick}
        disabled={pending}
        className="min-h-12 rounded-md border border-slate-300 bg-white px-4 text-left text-sm font-semibold text-slate-900 hover:border-slate-400 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {buttonLabel}
      </button>
      <span className={`min-w-26 text-right text-sm font-bold ${pillTone}`}>{pillText}</span>
    </div>
  );
}
